<script setup lang="ts">
import {ArrowLeft} from "@lucide/vue";

/**
 * The title of a renewal plan step, with a way back to the previous step.
 */

defineProps<{
    title: string;
    back?: boolean;
}>();

defineEmits(['back']);
</script>

<template>
  <div class="flex items-center gap-3">
    <button
      v-if="back"
      type="button"
      class="flex items-center justify-center shrink-0 size-9 rounded-full border-2 border-solid border-primary text-primary
        transition-opacity duration-200 hover:opacity-75"
      aria-label="Revenir à l'étape précédente"
      @click="$emit('back')"
    >
      <ArrowLeft class="size-5" :stroke-width="2.5" />
    </button>
    <h1 class="!m-0 text-primary">
      {{ title }}
    </h1>
  </div>
</template>
